var map = {
	"./american-flag-icon.svg": "./src/assets/svg/american-flag-icon.svg",
	"./background-lines.svg": "./src/assets/svg/background-lines.svg",
	"./building-icon.svg": "./src/assets/svg/building-icon.svg",
	"./canadian-flag-icon.svg": "./src/assets/svg/canadian-flag-icon.svg",
	"./current-calendar-icon.svg": "./src/assets/svg/current-calendar-icon.svg",
	"./delos-logo.svg": "./src/assets/svg/delos-logo.svg",
	"./duration-icon.svg": "./src/assets/svg/duration-icon.svg",
	"./filter-icon.svg": "./src/assets/svg/filter-icon.svg",
	"./icons-top.svg": "./src/assets/svg/icons-top.svg",
	"./logo-dark.svg": "./src/assets/svg/logo-dark.svg",
	"./logo-grayscale-dark.svg": "./src/assets/svg/logo-grayscale-dark.svg",
	"./mask-icon.svg": "./src/assets/svg/mask-icon.svg",
	"./oa-icon.svg": "./src/assets/svg/oa-icon.svg",
	"./occupancy-icon.svg": "./src/assets/svg/occupancy-icon.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/svg sync recursive ^\\.\\/.*\\.svg$";